<template>
  <div class="box">
    <div class="nav">
      <ul class="location">
        <li style="margin-right: 35px;">
          欢迎来到民众在线
          <!-- <Dropdown  placement="bottom-start">
            <a href="javascript:void(0)">
              <Icon type="ios-location" class="icon"></Icon> {{city}}
            </a>
            <DropdownMenu slot="list">
              <div class="city">
                <p v-for="(items, index) in cityArr" :key="index">
                  <span v-for="(item, index) in items"  class="city-item" :key="index" @click="changeCity(item)">{{item}}</span>
                </p>
              </div>
            </DropdownMenu>
          </Dropdown>-->
        </li>
        <li class="first " v-show="!uName">
          <router-link to="/login" class="first-log">请登录</router-link>
        </li>
        <li class="first" v-show="!uName">
          <span class="text-color-red register">
            <router-link to="/SignUp">注册 </router-link>
          </span>
        </li>
        <li v-show="uName">
          <Dropdown class="user-sort">
            <p class="username-p">
              <Avatar class="person-icon" icon="ios-person" :src="avatarSrc" size="small" />
              <span class="username" @click="toPersonal">{{ uName }} </span>
              <span class="sign-out" @click="signOutFun">[退出]</span>
            </p>
            <DropdownMenu slot="list">
              <div class="my-page">
                <p>
                  <router-link to="/personal/MyOrder">
                    <div class="img img1"></div>
                    <div class="my-txt">我的订单</div>
                  </router-link>
                </p>
                <p>
                  <router-link to="/personal/Balance">
                    <div class="img img2"></div>
                    <div class="my-txt">我的余额</div>
                  </router-link>
                </p>
                <p>
                  <router-link to="/PointsIndividual/MyScores">
                    <div class="img img3"></div>
                    <div class="my-txt">我的积分</div>
                  </router-link>
                </p>
                <p>
                  <router-link to="/personal/Favorites">
                    <div class="img img4"></div>
                    <div class="my-txt">我的收藏</div>
                  </router-link>
                </p>
                <p>
                  <router-link to="/personal/Coupon">
                    <div class="img img5"></div>
                    <div class="my-txt">我的优惠券</div>
                  </router-link>
                </p>
                <p>
                  <router-link to="/BuyingArea">
                    <div class="img img6"></div>
                    <div class="my-txt">我的求购</div>
                  </router-link>
                </p>
              </div>
            </DropdownMenu>
          </Dropdown>
        </li>
      </ul>
      <ul class="detail">
        <li>
          <a href="./static/uploads/民众在线.url" style="border-left: none;" download="民众在线.url" target="_blank">添加到桌面</a>
          <!-- <router-link to="/personal/MyOrder">我的订单</router-link> -->
        </li>
        <li>
          <router-link to="/personal/MyOrder">我的订单</router-link>
        </li>
        <li>
          <a href="http://jybg.ylmzyy.cn/" target="_blank">质检报告</a>
        </li>
        <!-- <li>
          <a href='http://124.115.222.186:9006/' target="_blank">求购专区</a>
        </li> -->
        <li>
          <router-link to="/BuyingArea" class="top-color-blue">求购专区</router-link>
        </li>
        <li>
          <Dropdown placement="bottom-start" class="phone-code">
            <Icon type="md-phone-portrait" />手机版
            <DropdownMenu slot="list">
              <img src="static\img\index\img\分组 27.png" alt="" />
            </DropdownMenu>
          </Dropdown>
        </li>
        <li>
          投诉电话：<span class="phone-num">0775-3268170</span>
        </li>
        <!--     <li><router-link to="/freeback">意见反馈</router-link></li>-->
        <!--  <li><router-link to="/">商城首页</router-link></li>-->
      </ul>
    </div>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "M-Header",
  // inject: ["reload"],
  created() {
    this.isLogin();
  },
  data() {
    return {
      uName: "",
    };
  },
  computed: {
    ...mapGetters(["userName", "userAllData"]),
    avatarSrc() {
      let src = '/static/img/index/img/user.png';
      if (this.userAllData && this.userAllData.heads) {
        src = this.userAllData.heads.startsWith('http://') ? this.userAllData.heads : process.env.BASE_URL + this.userAllData.heads ||
          "/static/img/index/img/user.png";
      }
      return src
    },
    zhijian() {
      let url = "http://221.2.68.62:10002";
      /* if (this.userAllData) {
        url+="?username="+this.userAllData.name+"&password="+this.userAllData.erpid;
      } */
      return url
    }
  },
  watch: {
    userAllData(newVal) {
      this.uName = newVal.name;
      console.log('名称变化--', newVal)
    },
    avatarSrc(newVal) {
      console.log('头像变化--', newVal)
    }
  },
  mounted() {
    console.log('名称变化11--', this.userName, this.userAllData)
    this.uName = this.userAllData.name;
  },
  methods: {
    ...mapActions(["signOut", "isLogin"]),
    toPersonal() {
      this.$router.push("/Personal/Rightpersonal");
    },
    changeCity(city) {
      this.city = city;
    },
    goToPay() {
      this.$router.push("/order");
    },
    myInfo() {
      this.$router.push("/home");
    },
    signOutFun() {
      // this.signOut();
      // this.$router.push("/");
      this.$confirm("确认退出系统吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: async action => {
          if (action === "cancel") return;

          this.$store
            .dispatch("user/logout")
            .then(() => {
              // this.$router.push("/Login")
              this.$router.replace({ path: '/Login' });
              sessionStorage.setItem('new_customer', '')
              this.reload();
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  },
  store
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 41px;
  background: #F8F8F8;
}

.nav {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.nav ul {
  list-style: none;
}

.nav li {
  float: left;
  font-size: 14px;
  line-height: 41px;
  margin-right: 15px;

  /*  font-weight: bold;*/
  .top-color-blue {
    color: #147A38;
  }

  .phone-num {
    color: #147A38;
  }
}

.nav li:last-child {
  margin-right: 0;
}

.nav a {
  text-decoration: none;
  color: #666;
  padding-left: 15px;
  border-left: 1px solid #E2E2E2;
  cursor: pointer;
}

.location a {
  border-left: none;
}

.nav a:hover {
  color: #147A38;
}

.location {
  font-size: 14px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666;
  line-height: 20px;
}

.icon {
  color: #147A38;
}

.first {
  font-size: 14px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666;
  line-height: 20px;
}

.first-log {
  padding-right: 15px;
  border-right: 1px solid #E2E2E2;
}

.detail {
  font-size: 14px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666;
  line-height: 20px;

  .register {
    padding-left: 15px;
    border-left: 1px solid #434343;
  }
}

.phone-code /deep/ .ivu-select-dropdown {
  margin: 0;
  padding: 0;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  border-radius: 0;
  box-shadow: 0 0 0 rgb(0 0 0 / 20%);
  z-index: 900;
}

.first a:first-child {
  padding-left: 3px;
  border-left: none;
}

.city {
  padding: 10px 15px;
}

.city-item {
  font-weight: bold;
  cursor: pointer;
  padding: 5px;
}

.city-item:hover {
  color: #147A38;
}

.person-icon {
  color: #666;
  background-color: #f1f1f1;
}

.username {
  color: #147A38;
}

.sign-out {
  color: #666;
}

.shopping-cart-list {
  padding: 3px 15px;
}

.shopping-cart-box {
  margin: 8px 0px;
  margin-top: 15px;
  padding-bottom: 15px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px #ccc dotted;
}

.shopping-cart-box:first-child {
  margin-top: 8px;
}

.shopping-cart-img {
  margin-right: 15px;
  width: 40px;
  height: 40px;
}

.shopping-cart-img img {
  width: 100%;
}

.shopping-cart-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  width: 200px;
  overflow: hidden;
  font-size: 12px;
  line-height: 20px;
  color: #666;
}

.shopping-cart-detail {
  color: #666;
}

.shopping-cart-text {
  color: #ccc;
}

.go-to-buy {
  display: flex;
  justify-content: flex-end;
}

.shopping-cart-null {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cart-null-icon {
  font-size: 38px;
  margin-bottom: 15px;
}

.shopping-cart-null span {
  color: #666;
  font-size: 12px;
  line-height: 16px;
}

.user-sort /deep/ .ivu-select-dropdown {
  margin: 0;
  padding: 0;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  border-radius: 0;
  box-shadow: 0 0 0 rgb(0 0 0 / 20%);
  z-index: 900;
}

.user-sort {
  .username-p {
    cursor: pointer;
  }

  .my-page {
    width: 140px;
    height: 210px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(174, 174, 174, 0.2);
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    box-sizing: border-box;
    padding: 13px 0 0 0;

    p {
      width: 100%;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      text-align: center;
      height: 30px;
      line-height: 30px;
    }

    p a {
      display: block;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      text-align: center;
    }

    a:hover {
      color: #147A38;
      background-color: #f6f6f6;
    }

    .my-txt {}

    .img {
      width: 22px;
      height: 22px;
      margin: 0 6px 0 18px;
    }

    .img1 {
      background: url(/static/img/index/indexIcon.png) no-repeat -19px -120px;
    }

    .img2 {
      background: url(/static/img/index/indexIcon.png) no-repeat -127px -153px;
    }

    .img3 {
      background: url(/static/img/index/indexIcon.png) no-repeat -201px -120px;
    }

    .img4 {
      background: url(/static/img/index/indexIcon.png) no-repeat -280px -120px;
    }

    .img5 {
      background: url(/static/img/index/indexIcon.png) no-repeat -55px -154px;
    }

    .img6 {
      background: url(/static/img/index/indexIcon.png) no-repeat -127px -120px;
    }
  }

  .my-page a {
    margin: 0px;
    padding: 0px;
    border: none;
  }

  .my-page a:hover .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -55px -120px;
  }

  .my-page a:hover .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -91px -153px;
  }

  .my-page a:hover .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -162px -120px;
  }

  .my-page a:hover .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -241px -120px;
  }

  .my-page a:hover .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -19px -154px;
  }

  .my-page a:hover .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -91px -120px;
  }
}

.my-info {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}

.my-info:hover {
  box-shadow: 0px 0px 5px #ccc;
}

.my-info i {
  font-size: 28px;
}

.my-info p {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue